export default __webpack_public_path__ + "static/media/bo.1f173360.jpg";